import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputHelperTextComponent } from 'app/shared/components/input-helper-text/input-helper-text.component';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-toggle-switch-form-field',
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, InputHelperTextComponent],
  templateUrl: './toggle-switch-form-field.component.html',
  styleUrl: './toggle-switch-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleSwitchFormFieldComponent),
      multi: true,
    }
  ],
})
export class ToggleSwitchFormFieldComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() helpText!: string;

  formControl: FormControl = new FormControl<string>('');
  errorText: string = '';

  private unsubscribe$ = new Subject<void>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  onTouch: () => void = () => {};
  onChange: (value: any) => void = () => {};

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(value: string): void {
    this.formControl.setValue(value, { emitEvent: false });

    this.changeDetectorRef.markForCheck();
  }

  ngOnInit(): void {
    this.formControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe((value) => {
        this.onChange(value);
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
